import _ from "lodash";
import store from "services/redux/store";
import { addBookingsByKey } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchBookingInvitationReceived from "utils/fetch/FetchBookingInvitationReceived";

export default class FetchCachedBookingInvitationReceived
{
	static logName = 'FetchCachedBookingInvitationReceived';
	static values = null;
	static cacheUpdatedAt = null;

	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'invitations_received',
				tables: [ 'my_invitations_received' ],
				onExpire: FetchCachedBookingInvitationReceived.reload,
				updated_at_max_age: ( 2 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};
	
	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () => {
			return FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess({
							bookings: this.values,
						});
					}
				},
				onExpired: () => {
					this.reload( { callbackSuccess, callbackError, callbackStart } )
				}
			});
		});
	}

	/**
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 */
	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchBookingInvitationReceived.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( { bookings = null } ) => {

						// When set add the bookings to the store
						this.process( bookings )

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, bookings, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) )
						{
							callbackSuccess( {
								bookings: bookings,
							} );
						}

					}
				})
			);
		}
		)
	}
	
	static process = ( invitations ) => {
		this.values = invitations;
		
		// Add a sort by key
		_.forEach( this.values, item => {
			item.sort_by = item.booking_date;
		})
		
		store.dispatch( addBookingsByKey( dataConstants.BOOKINGS, this.values ) );
	}
}
